import React from "react";

const ReferAndEarn = ({ landingPageData }) => {
  return (
    <div id="how-it-works">
      {/* Blue background section */}
      <div
        className="relative bg-right bg-no-repeat bg-cover p-8 lg:max-h-420"
        style={{
          backgroundImage: 'url("/images/ReferAndEarn/blue-bg.webp")',
        }}
      >
        <div className=" text-white lg:py-16 mx-auto h-full flex flex-col items-center justify-center ">
          {/* "Refer & Earn" heading */}
          <div>
            <h2 className="text-30 lg:text-34 font-bold text-center">
              {landingPageData.referAndEarn.title2}
            </h2>
          </div>
          {/* "How it works" section */}
          <div className=" text-12 lg:text-14 font-[400] bg-white rounded-full min-w-100 lg:min-w-150 text-center p-2 text-blue mt-4">
            <h1>{landingPageData.referAndEarn.title1}</h1>
          </div>

          {/* Steps Section */}
          <div className="grid grid-cols-1 lg:px-20 lg:grid-cols-3 gap-10 mt-8">
            {landingPageData.referAndEarn.steps.map((step, index) => (
              <div
                key={index}
                className="bg-white max-w-[393px] rounded-3xl p-6 shadow-md"
              >
                <div className="flex flex-col items-center">
                  <img src={step.icon} alt="program" className="w-20 h-20" />
                  <h3 className="text-xl font-[900] mb-4 mt-4 text-referCardTitle">
                    {step.stepNumber}. {step.title}
                  </h3>
                </div>
                <ul className="list-none space-y-6 text-textBlack">
                  {step.description.map((description, index) => (
                    <li key={index} className="flex">
                      <img
                        src="/images/ReferAndEarn/right.webp"
                        alt="arrow"
                        className="inline-block w-6 h-6 mr-2"
                      />
                      <p className="text-16">{description}</p>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferAndEarn;
